import type { IconGlyph } from '../icon';

import { iconKeyThick } from './key-thick';

/**
 * Tractie `key` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/key.jsx`.
 * Verbatim copy of the SVG `d` attributes, 2 paths in source order.
 */
export const iconKey: IconGlyph = {
  name: 'key',
  path: [
    'M17 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1',
    'M15.5 2a6.5 6.5 0 0 0-6 9L2 18.5V22h4l1-1.5-.5-1.5.5-.5 1.5.5 1-1-.5-1.5.5-.5 1.5.5 2-2A6.5 6.5 0 1 0 15.5 2m0 12c-.98 0-1.91-.26-2.7-.71l-2.07 2.07-1.5-.5-1.37 1.37.5 1.5-.13.13-1.5-.5-1.37 1.37.54 1.62-.43.65H3.01v-2.09l7.71-7.71A5.497 5.497 0 0 1 15.51 3c3.04 0 5.5 2.46 5.5 5.5s-2.46 5.5-5.5 5.5Z',
  ],
  selected: iconKeyThick,
};
